export const splitTires = (orderObjectId: string) => {
	return {
		method: "PUT",
		url: `${process.env.REACT_APP_ORIGIN}/work_order_utility/split-tires`,
		body: {
			orderObjectId,
		},
	}
}
